/*********************** Custom JS for Boost AI Search & Discovery  ************************/

// function calc width of input and set result
const calcAndSetResultEqualInputSearch = () => {
  // get current Input of page
  const widthInput = document.querySelector(
    '.search__form, #home-search .search-form_input-wrapper, header .banner-search form.search-form.search-bar_form[role="search"]'
  )?.offsetWidth;

  // get current result is showing
  const currentResult = document.querySelectorAll(
    "div.boost-sd__search-widget-init-wrapper:not(.boost-sd_g-hide)"
  );

  if (currentResult?.length == 0) return;

  if (widthInput > 0) {
    for (let searchWidget of currentResult) {
      searchWidget
        ?.querySelector(".boost-sd__instant-search-results")
        ?.setAttribute("style", "width: " + widthInput + "px;");
    }
  }
};

// when window resize -> re-run
// onresize = (event) => {
//     calcAndSetResultEqualInputSearch();
// };

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  (componentRegistry) => {
    componentRegistry.useComponentPlugin("SearchContentResult", {
      name: "SearchContentResult - set width result equal input",
      apply() {
        return {
          afterRender(element) {
            calcAndSetResultEqualInputSearch();
          },
        };
      },
    });

    componentRegistry.useComponentPlugin("ProductTitle", {
      name: "Modify Component ProductTitle",
      enabled: true,
      apply: () => ({
        afterRender(element) {
          try {
            const titleElm = element.getRootElm();
            const productData = element
              .getParentElm()
              .getParentElm()
              .getParentElm()
              .getParams().props.product;
            let productItem = document.querySelector(
              '[data-product-id="' + productData.id + '"]'
            );
            const SKU = productData.skus[0];

            if (
              titleElm &&
              SKU &&
              productItem &&
              !productItem.querySelector(".sku-name")
            ) {
              const SKUElm = document.createElement("div");
              SKUElm.classList.add("sku-name");
              SKUElm.textContent = SKU;
              titleElm.after(SKUElm);
            }
          } catch (error) {
            console.log(error);
          }
        },
      }),
    });
  },
]);

function getProductMetafield(productData, namespace, key) {
  if (productData.hasOwnProperty("metafields")) {
    var metafieldValue = productData["metafields"].filter(function (e) {
      return e.namespace == namespace && e.key == key;
    });
    if (typeof metafieldValue[0] !== "undefined") {
      return metafieldValue[0]["value"];
    }
  }
  return null; //Return null if metafield does not exist
}

const customize = {
  updateProductItemGrid: (componentRegistry) => {
    componentRegistry.useComponentPlugin("ProductItem", {
      name: "Add extra information",
      enabled: true,
      apply: () => ({
        afterRender(element) {
          // Start customization--------------------------------------------
          let productData = element.getParams().props.product;
          handleAdditonalElemts(productData);
        },
      }),
    });
  },

  updateProductItemISW: (componentRegistry) => {
    componentRegistry.useComponentPlugin("SearchProductItem", {
      name: "Customize product item ISW",
      enabled: true,
      apply: () => ({
        afterRender(element) {
          // Start customization--------------------------------------------
          let productData = element.getParams().props.product;
          handleAdditionalElementsOnISW(productData);
        },
      }),
    });
  },
};

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  customize.updateProductItemGrid,
]);

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  customize.updateProductItemISW,
]);

function getWindowLocation() {
  // Escape window.location.href
  var href = window.location.href;
  var escapedHref = href.replace(/%3C/g, "&lt;").replace(/%3E/g, "&gt;");

  // Rebuild window.location.href
  var rebuildHrefArr = [];
  for (var i = 0; i < escapedHref.length; i++) {
    rebuildHrefArr.push(escapedHref.charAt(i));
  }
  var rebuildHref = rebuildHrefArr
    .join("")
    .split("&lt;")
    .join("%3C")
    .split("&gt;")
    .join("%3E");

  // Rebuild window.location.search
  var rebuildSearch = "";
  var hrefWithoutHash = rebuildHref.replace(/#.*$/, "");
  if (hrefWithoutHash.split("?").length > 1) {
    rebuildSearch = hrefWithoutHash.split("?")[1];
    if (rebuildSearch.length > 0) {
      rebuildSearch = "?" + rebuildSearch;
    }
  }

  return {
    pathname: window.location.pathname,
    href: rebuildHref,
    search: rebuildSearch,
  };
}

function isSearchPage() {
  // An URL of Google cache will look like this: webcache.googleusercontent.com/search?q=cache:xxx:https://xxx.xxx/search?xxx
  // Google cache URL
  if (getWindowLocation().href.includes("webcache.googleusercontent.com")) {
    return getWindowLocation().search.indexOf("search?") > -1;

    // Normal URL
  } else {
    return window.location.pathname.indexOf("/search") > -1;
  }
}

function getMetafieldDimensions(productData) {
  // Assuming productData has length, width, and height
  let length = getProductMetafield(
    productData,
    "restaurantware",
    "spec_length"
  );
  let width = getProductMetafield(
    productData,
    "restaurantware",
    "spec_width"
  );
  let height = getProductMetafield(
    productData,
    "restaurantware",
    "spec_height"
  );

  const dimensions = [length, width, height]; // Assuming dimensions are in inches

  let isCustomizableProduct = getProductMetafield(
    productData,
    "restaurantware",
    "is_customizable_product"
  );

  let customizableMinPrice = getProductMetafield(
    productData,
    "restaurantware",
    "czbl_min_price"
  );
  
  let result_list = '';
  
  dimensions.forEach((num, index) => {
    let result = '';

      // Convert to fractional inches
      let temp = num * 4;
      let rounded = Math.round(temp);
      let integer_part = Math.floor(rounded / 4);
      let fraction_part = rounded % 4;

      if(integer_part > 1){
        if (fraction_part === 0) {
          result = integer_part;
        } else if (fraction_part === 1) {
          result = `${integer_part} 1/4`;
        } else if (fraction_part === 2) {
          result = `${integer_part} 1/2`;
        } else if (fraction_part === 3) {
          result = `${integer_part} 3/4`;
        } else {
          result = integer_part + 1;
        }
    }

    // Append result with quotes and concatenate results with ' x '
    if (result !== '') {
      result = result + '"';
      if (result_list !== '') {
        result_list += ' x ';
      }
      result_list += result;
    }
  });

  return result_list;
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat(
  (registry) => {
    registry.useModulePlugin("SearchAPI", {
      name: "Customize search API",
      apply(builder) {
        // Logic for in collection search feature, please only edit in TODO
        builder.on("beforeMethodCall", "searchInCollection", (payload) => {
          const filterParams = payload.args[0];
          let isApiFilterInSearchPage = false;
          if (!filterParams) return;

          const keys = Object.keys(filterParams);
          console.log(keys);
          if (keys?.length > 0) {
            for (let i = 0; i < keys.length; i++) {
              if (keys[i].startsWith("pf_")) {
                isApiFilterInSearchPage = true;
                break;
              }
            }
          }

          // Logic runs before filtering in search results page, please only edit in TODO
          if (isSearchPage()) {
            // TODO 1
            payload.args[0].h_options = ["retail"]; // Add new param h_options
            // END TODO
          }
        });

        // Logic run before calling API on ISW, please only edit in TODO
        builder.on("beforeMethodCall", "get", (payload) => {
          // TODO 2
          if (!payload.args[2]) {
            payload.args[2] = {};
          }
          payload.args[2].h_options = ["retail"]; //Add new param h_options
          // END TODO
        });
      },
    });
  }
);


if (window.boostSDAppConfig) {
  boostSDAppConfig.generalSettings.no_image_url = "https://cdn.shopify.com/s/files/1/0785/3155/9744/files/rw_placeholder.png?"
}

const supportB2bPlugin = {
  name: 'Support B2B',
  apply(builder) {
    builder.on('beforeMethodCall', 'get', (payload) => {
      try {
        const appConfig = window.boostSDAppConfig;
  
        payload.args[2].limit = 30;
        payload.args[2].company_location_id = `${appConfig.b2b.current_company_id}_${appConfig.b2b.current_location_id}`;
        const shopifyCurrencySettings = window.Shopify?.currency;
        payload.args[2].currency = shopifyCurrencySettings?.active;
        payload.args[2].currency_rate = shopifyCurrencySettings?.rate;
      } catch ({ name, message }) {
        console.warn(name,': ',message);
      }
    });
  }
}
// window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
//   (componentRegistry) => {
//     const appConfig = window.boostSDAppConfig;
//     if (appConfig.b2b.enabled) {
//       console.log('appConfig.b2b.enabled')
//       componentRegistry.useModulePlugin('FilterAPI', supportB2bPlugin);
//       componentRegistry.useModulePlugin('RecommendationAPI', supportB2bPlugin);
//       componentRegistry.useModulePlugin('SearchAPI', supportB2bPlugin);
//       componentRegistry.useModulePlugin('SearchAPI', {
//         name: 'Support B2B',
//         apply(builder) {
//           builder.on('beforeMethodCall', 'searchInCollection', (payload) => {
//             payload.args[0].limit = 30;
//             payload.args[0].company_location_id = `${appConfig.b2b.current_company_id}_${appConfig.b2b.current_location_id}`;
//             const shopifyCurrencySettings = window.Shopify?.currency;
//             payload.args[0].currency = shopifyCurrencySettings?.active;
//             payload.args[0].currency_rate = shopifyCurrencySettings?.rate;
//           });
//         }
//       })
//     }
//   }
// ]);


// B2B Price
const checkCustomerIsLogged = window.boostSDData?.customer?.isLogged;
const customize_B2B_price = (componentRegistry) => {
  componentRegistry.useModulePlugin("FilterAPI", {
    name: "custom collection page",
    apply(builder) {
      builder.on("methodFulfilled", "get", (data) => {
        async function customFunction(data) {
          const callAjaxArr = data.result.products.map(async (product) => {
            await handleAjax(product);
            handleAdditonalElemts(product);
            return product;
          });
          Promise.all(callAjaxArr).then((values) => {
            handleSwatchEvents();
          });
        }
        if (checkCustomerIsLogged) {
          customFunction(data);
        }
      });
    },
  });
  componentRegistry.useModulePlugin("RecommendationAPI", {
    name: "custom recommendation widgets",
    apply(builder) {
      builder.on("methodFulfilled", "get", (data) => {
        async function customFunction(data) {
          const callAjaxArr = data.result.products.map(async (product) => {
            await handleAjax(product);
            handleAdditonalElemts(product);
            return product;
          });
          Promise.all(callAjaxArr).then((values) => {
            handleSwatchEvents();
          });
        }
        if (checkCustomerIsLogged) {
          customFunction(data);
        }
      });
    },
  });
  componentRegistry.useModulePlugin("SearchAPI", {
    name: "custom search page",
    apply(builder) {
      builder.on("methodFulfilled", "searchInCollection", (data) => {
        async function customFunction(data) {
          const callAjaxArr = data.result.products.map(async (product) => {
            await handleAjax(product);
            handleAdditonalElemts(product);
            return product;
          });
          Promise.all(callAjaxArr).then((values) => {
            handleSwatchEvents();
          });
        }
        if (data.result && data.result.hasOwnProperty("filter")) {
          if (checkCustomerIsLogged) {
            customFunction(data);
          }
        }
      });

      // param on ISW
      // builder.on('methodFulfilled', 'get', (payload) => {
      //   if (!payload.args[2]) {
      //     payload.args[2] = {};
      //   }
      //   async function customFunction(data) {
      //     const callAjaxArr = data.result.products.map(async (product) => {
      //       await handleAjaxISW(product);
      //       return product;
      //     });
      //     Promise.all(callAjaxArr).then((values) => {
      //       handleSwatchEvents();
      //     });
      //   }
      //   console.log(payload);
      //   if (payload.result && payload.result.products) {
      //     customFunction(payload);
      //   }
      // });
    },
  });

  componentRegistry.useComponentPlugin("SearchProductItem", {
    name: "Customize product price",
    enabled: true,
    apply: () => ({
      afterRender(element) {
        try {
          let productData =
            element.getParams()?.props?.product ||
            element.getParams()?.props?.productData ||
            element.getParams()?.props?.data;
          let productItem = document.querySelector(
            '.boost-sd__suggestion-queries-item[data-id="' + productData.id + '"]',
          );
          if (!productItem) return;
          var activeCountry = Shopify.country;
          if (checkCustomerIsLogged) {
            handleAjaxISW(productData);
          }
        } catch (e) {}
      },
    }),
  });
};

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize_B2B_price]);

async function handleAjax(productData) {
  let productHandleAjax = Shopify.routes.root + "products/" + productData.handle + "?view=boost-sd-custom-integration";
  let requestReg = await formRequest(productHandleAjax);
  try {
    let parse_res_success = JSON.parse(requestReg);
    let productTargetEl = document.querySelector('.boost-sd__product-item[id="' + parse_res_success.id + '"]');
    if (!productTargetEl) return;
    productTargetEl.querySelector('.boost-sd__product-price-content').innerHTML = buildB2BPrice(parse_res_success);
    productTargetEl.querySelector('.boost-sd__product-price-content').classList.add('boost-sd-showing');
  } catch (error) {
    console.log(productHandleAjax, error);
  }
}
async function handleAjaxISW(productData) {
  let productHandleAjax = Shopify.routes.root + "products/" + productData.handle + "?view=boost-sd-custom-integration";
  let requestReg = await formRequest(productHandleAjax);
  try {
    let parse_res_success = JSON.parse(requestReg);
    let productTargetEl = document.querySelector('.boost-sd__suggestion-queries-item--product[data-id="' + parse_res_success.id + '"]');
    if (!productTargetEl) return;
    productTargetEl.querySelector('.boost-sd__suggestion-queries-item-price').innerHTML = buildB2BPrice(parse_res_success, true);
    productTargetEl.querySelector('.boost-sd__suggestion-queries-item-price').classList.add('boost-sd-showing');
    handleAdditionalElementsOnISW(productData);
  } catch (error) {
    console.log(productHandleAjax, error);
  }
}

function formRequest(value) {
  return new Promise((resolve, reject) => {
    var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP");
    xhr.open("GET", value);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.onload = () => resolve(xhr.responseText);
    xhr.onerror = () => reject(xhr.statusText);
    xhr.send();
  });
}

function handleSwatchEvents() {
  
}
function buildB2BPrice(data, isw = false) {
  var html = '';
  var onSale = data.compare_at_price_min > data.price_min;
  if (isw) {
    if (onSale) {
      html = `
        <span class="boost-sd__suggestion-queries-item-amount boost-sd__suggestion-queries-item-amount--sale">
          <span class="boost-sd__format-currency boost-sd__format-currency--price-sale">
            <span class="">${formatMoney(data.price_min)}</span>
          </span>
          <span class="boost-sd__format-currency boost-sd__format-currency--price-compare">
            <span class="">${formatMoney(data.compare_at_price_min)}</span>
          </span>
        </span>
      `;
    } else {
      html = `
        <span class="boost-sd__suggestion-queries-item-amount boost-sd__suggestion-queries-item-amount--regular">
          <span class="boost-sd__format-currency">
            <span class="">${formatMoney(data.price_min)}</span>
          </span>
        </span>
      `;
    }
  } else {
    if (onSale) {
      html = `
        <span class="boost-sd__format-currency" style="color: rgb(240, 81, 95); font-size: 16px;">
          <span class="">${formatMoney(data.price_min)}</span>
        </span>
        <span class="boost-sd__format-currency boost-sd__format-currency--price-compare" style="color: rgb(148, 148, 148); font-size: 16px;">
          <span class="">${formatMoney(data.compare_at_price_min)}</span>
        </span>
      `;
    } else {
         html = `
          <span class="boost-sd__format-currency" style="color: rgb(34, 34, 34); font-size: 16px;">
            <span class="">${formatMoney(data.price_min)}</span>
          </span>
        `;
    }
  }
  return html;
}
const formatMoney = (money, format, withoutTrailingZeros) => {
  if (typeof format == "undefined") format = boostSDAppConfig.shop.money_format;
  if (format == "money_with_currency") format = boostSDAppConfig.shop.money_format_with_currency;
  if (typeof withoutTrailingZeros == "undefined") var withoutTrailingZeros = false;
  // if (typeof Shopify.formatMoney === 'function') { return Shopify.formatMoney(money, format); }
  if (typeof money == "string") {
    money = money.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || "${{amount}}";

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = parseFloat(number).toFixed(precision);
    var parts = number.split(".");
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
    var money = parts[1] ? decimal + parts[1] : "";
    return withoutTrailingZeros == true ? (dollars + money).replace(/((\,00)|(\.00))$/g, "") : dollars + money;
  }

  var matches = formatString.match(placeholderRegex);
  var match = matches && matches.length > 1 ? matches[1] : "";
  switch (match) {
    case "amount":
      value = formatWithDelimiters(money, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(money, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(money, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(money, 0, ".", ",");
      break;
    case "amount_with_space_separator_no_comma":
      value = formatWithDelimiters(money, 2);
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(money, 0, " ", ".");
      break;
    default:
      value = formatWithDelimiters(money, 2);
      break;
  }
  formatString = formatString.replace(placeholderRegex, value);

  return formatString;
};

// Add custom item to price
function handleAdditonalElemts(productData) {  
  try {
    // Start customization--------------------------------------------
    let productId = productData.id;
    if (productData?.split_product) {
      productId = productData.variant_id;
    }
    if (productData) {
      const productJsonArray = productData.collections;

      // Check if the array is not empty and the object exists at the specified index
      if (
        productJsonArray.length > 0 &&
        productJsonArray[0] &&
        productJsonArray[0].title
      ) {
        // Access the 'title' property
        const categoryName = productJsonArray[0].title;

        // Print the value of the 'title' property
        //console.log(categoryName); // Output: Coffee Cups
        const baseProductLink = "/products/" + productData.handle;
        //console.log(baseProductLink);

        let productItemObj = document.querySelector(
          '[data-product-id="' + productId + '"]'
        );
        // Update the handle for product card
        productItemObj
          .querySelector(
            ".boost-sd__product-item-grid-view-layout-image .boost-sd__product-link-image"
          )
          .setAttribute("href", baseProductLink);

        productItemObj
          .querySelector(
            ".boost-sd__product-item > .boost-sd__product-link"
          )
          .setAttribute("href", baseProductLink);
      } else {
        console.log(
          "Search Result Page: Either the array is empty or the object at index 0 doesn't have a 'title' property."
        );
      }
    }

    let productItem = document.querySelector(
      '[data-product-id="' + productId + '"]'
    );

    let productItems = document.querySelectorAll(
      '[data-product-id="' + productId + '"]'
    );

    if (productItems.length > 0) {
      productItems.forEach((item) => {
        if (item) {
          const is_customize_product = getProductMetafield(
            productData,
            "restaurantware",
            "is_customizable_product"
          );
          
          const brand_name = getProductMetafield(
            productData,
            "restaurantware",
            "brand_name"
          );
          const subtitle = getProductMetafield(
            productData,
            "descriptors",
            "subtitle"
          );
          // const dimension = getProductMetafield(
          //   productData,
          //   "restaurantware",
          //   "dimension"
          // );
          let dimension = getProductMetafield(
                productData, 
                "restaurantware", 
                "dimension"
             );

            if (dimension === null || dimension === undefined) {
              dimension = getMetafieldDimensions(productData);
            }
          
          const count_box = getProductMetafield(
            productData,
            "restaurantware",
            "count_box"
          );
          const Customizable_least_quantity = getProductMetafield(
            productData,
            "restaurantware",
            "czbl_quantity"
          );
          const is_max = getProductMetafield(
            productData,
            "restaurantware",
            "is_max"
          );
          const is_retail = getProductMetafield(
            productData,
            "restaurantware",
            "is_retail"
          );
          const czbl_min_price = getProductMetafield(
            productData,
            "restaurantware",
            "customizable_product_min_price"
          );
          const SKU = productData.skus[0];

          const brandNameHTML =
            brand_name != null
              ? `<div class="boost-sd-meta brandname caption-with-letter-spacing brand-name">${brand_name}</div>`
              : "<div class='boost-sd-meta'></div>";
          const subtitleHTML =
            subtitle != null
              ? `<div class="boost-sd-meta subtitle card__title">${subtitle}</div>`
              : "<div class='boost-sd-meta subtitle'></div>";
          const dimensionHTML =
            dimension != null
              ? `<div class="boost-sd-meta dimension card__description">${dimension}</div>`
              : "<div class='boost-sd-meta dimension'></div>";
          const skuHTML =
            SKU != null
              ? `<div class="boost-sd-meta sku sku-name">${SKU}</div>`
              : "<div class='boost-sd-meta sku'></div>";
          // const countboxHTML =
          //   count_box != null && SKU != "EXPOMIDATL25" && SKU != "EXPOBOSTON25"
          //     ? `<span class="boost-sd-meta count-box">/${count_box} count box</span>`
          //     : "<div class='boost-sd-meta count-box'></div>";

          let displayQuantity = count_box;
          if (is_customize_product === "true" || is_customize_product === true) {
            displayQuantity = "piece" || count_box;
          }
          
          const countboxHTML =
            displayQuantity != null && SKU != "EXPOMIDATL25" && SKU != "EXPOBOSTON25"
              ? `<span class="boost-sd-meta count-box">/${displayQuantity} ${is_customize_product === "true" || is_customize_product === true ? '' : 'count box'}</span>`
              : "<div class='boost-sd-meta count-box'></div>";

          const minQtyHTML =
            Customizable_least_quantity != null
              ? `<span class="boost-sd-meta count-box"></span>`
              : "<div class='boost-sd-meta count-box'></div>";

          const isMAXHTML = is_max
            ? `<div class="is-max-true light-max-logo">
              <img class=rwMax-img src="https://cdn.shopify.com/s/files/1/0780/9987/4066/files/rwMax_logo.png" alt="Special Product">
            </div>
            <div class="is-max-true dark-max-logo">
              <img class=rwMax-img src="https://cdn.shopify.com/s/files/1/0780/9987/4066/files/unnamed_20.png" alt="Special Product">
            </div>`
            : "";

          const customizableBadgeHTML = (is_customize_product === "true" || is_customize_product === true)
            ? `<span class="customizable-badge" aria-hidden="true" style="display: flex; position: absolute; z-index: 1; top: 21px; width: 126px;">
                <img src="https://cdn.shopify.com/s/files/1/0780/9987/4066/files/customizable_badge_icon_1.png" style="max-width: 14px" alt="Customizable Icon">
                Customizable
              </span>`
            : "";

          if (!item.querySelector(".brandname")) {
            item
              .querySelector(".boost-sd__product-info")
              .insertAdjacentHTML("beforebegin", brandNameHTML);
          }

          if (!item.querySelector(".subtitle")) {
            item
              .querySelector(".boost-sd__product-info")
              .insertAdjacentHTML("beforebegin", subtitleHTML);
          }

          if (!item.querySelector(".dimension")) {
            item
              .querySelector(".subtitle")
              .insertAdjacentHTML("afterend", dimensionHTML);
          }

          if (!item.querySelector(".sku")) {
            item
              .querySelector(".boost-sd__product-price")
              .insertAdjacentHTML("beforebegin", skuHTML);
          }

          if (!item.querySelector(".count-box")) {
            item
              .querySelector(".boost-sd__format-currency")
              .insertAdjacentHTML("beforeend", countboxHTML);
          }
          if (!productItem.querySelector(".rwMax-img")) {
            productItem
              .querySelector(
                ".boost-sd__product-item-grid-view-layout-image"
              )
              .insertAdjacentHTML("beforeend", isMAXHTML);
          }

          // Add customizable badge to product image
                    // Ensure badge and class are added on every render, including after scroll/infinite load
          if (is_customize_product === "true" || is_customize_product === true) {
            const productImageContainer = item.querySelector(
              ".boost-sd__product-item-grid-view-layout-image"
            );
            if (productImageContainer && !productImageContainer.querySelector(".customizable-badge")) {
              productImageContainer.insertAdjacentHTML("beforeend", customizableBadgeHTML);
            }

            // Add customProduct class to quick view if exists
            let quickViewEl = document.querySelector('.boost-sd__quick-view[data-product-id="' + productId + '"]');
            if (quickViewEl && !quickViewEl.classList.contains("customProduct")) {
              quickViewEl.classList.add("customProduct");
            }

            let productImage = item.querySelector(".boost-sd__product-image") ||
              item.querySelector(".boost-sd__product-item-grid-view-layout-image") ||
              item.querySelector(".boost-sd__product-link-image") ||
              item;

            if (productImage && !productImage.classList.contains("customProduct")) {
              productImage.classList.add("customProduct");
            }

            // Prepend 'From' to .boost-sd__format-currency
            const currencyEl = item.querySelector(".boost-sd__format-currency");
            // if (currencyEl) {
            //   currencyEl.style.display = "none";
            // }
            if (currencyEl && !currencyEl.querySelector(".from-text")) {
              currencyEl.insertAdjacentHTML("afterbegin", '<span class="from-text" style="font-size: 12px; margin-right: 2px;">From</span>');
            }

            // Update the price text to your desired value
            const priceEl = currencyEl ? currencyEl.querySelector("span:not(.from-text):not(.count-box)") : null;
            if (priceEl) {
              priceEl.textContent = czbl_min_price ? `$${czbl_min_price}` : ""; // Show czbl_min_price if available
            }

            // Always try to add countboxHTML if not present
            const currencyContainer = item.querySelector(".boost-sd__format-currency");
            if (currencyContainer && !currencyContainer.querySelector(".count-box")) {
              currencyContainer.insertAdjacentHTML("beforeend", countboxHTML);
            }
          }
            if (is_customize_product === "true" || is_customize_product === true) {
              // Change "Add to cart" button text to "Select & Design"
              const addToCartBtn = item.querySelector('.boost-sd__btn-add-to-cart .boost-sd__button-text');
              if (addToCartBtn) {
                addToCartBtn.textContent = "Select & Design";
                const baseProductLink = "/products/" + productData.handle;
                const addToCartLink = item.querySelector('.boost-sd__btn-add-to-cart');
                if (addToCartLink) {
                  // Remove all default add-to-cart behavior
                  addToCartLink.removeAttribute("data-boost-cart");
                  addToCartLink.setAttribute("href", baseProductLink);
                  addToCartLink.setAttribute("target", "_self");
                  // Remove any existing click handlers by replacing the element
                  const newLink = addToCartLink.cloneNode(true);
                  newLink.addEventListener("click", function(e) {
                    e.preventDefault();
                    window.location.href = baseProductLink;
                  });
                  addToCartLink.parentNode.replaceChild(newLink, addToCartLink);
                }
              }
            }
        }
      });
    }
  } catch (e) {
    console.warn(e);
  }
}

function handleAdditionalElementsOnISW(productData) {
  try {
    // Start customization--------------------------------------------
    let productId = productData.id;
    if (productData?.split_product) {
      productId = productData.variant_id;
    }

    if (productData) {
      const productJsonArray = productData.collections;

      // Check if the array is not empty and the object exists at the specified index
      if (
        productJsonArray.length > 0 &&
        productJsonArray[0] &&
        productJsonArray[0].title
      ) {
        // Access the 'title' property
        const categoryName = productJsonArray[0].title;

        // Print the value of the 'title' property
        //console.log(categoryName); // Output: Coffee Cups
        const baseProductLink = "/products/" + productData.handle;
        //console.log(baseProductLink);

        let productItemObj = document.querySelector(
          '[data-id="' + productId + '"]'
        );
        // Update the handle for product card
        productItemObj
          .querySelector(
            ".boost-sd__suggestion-queries-item--product > a.boost-sd__suggestion-queries-item-link"
          )
          ?.setAttribute("href", baseProductLink);
      } else {
        console.log(
          "Search Result Page: Either the array is empty or the object at index 0 doesn't have a 'title' property."
        );
      }
    }

    let productItem = document.querySelector(
      '.boost-sd__suggestion-queries-item--product[data-id="' +
        productId +
        '"]'
    );
    const is_customize_product = getProductMetafield(
      productData,
      "restaurantware",
      "is_customizable_product"
    );
    const brand_name = getProductMetafield(
      productData,
      "restaurantware",
      "brand_name"
    );
    const subtitle = getProductMetafield(
      productData,
      "descriptors",
      "subtitle"
    );
    // const dimension = getProductMetafield(
    //   productData,
    //   "restaurantware",
    //   "dimension"
    // );
       let dimension = getProductMetafield(
           productData, 
           "restaurantware", 
           "dimension"
        );

        if (dimension === null || dimension === undefined) {
            dimension = getMetafieldDimensions(productData);
         }
    
    const count_box = getProductMetafield(
      productData,
      "restaurantware",
      "count_box"
    );

    const Customizable_least_quantity = getProductMetafield(
      productData,
      "restaurantware",
      "czbl_quantity"
    );
    let qty = count_box;
    if (!qty || qty === "" || qty === null || qty === undefined) {
      qty = Customizable_least_quantity;
    }
    if (is_customize_product) {
      qty = "";
    }

    const is_retail = getProductMetafield(
      productData,
      "restaurantware",
      "is_retail"
    );

    const is_customizeProduct = getProductMetafield(
      productData,
      "restaurantware",
      "is_customizable_product"
    );

    const czbl_min_price = getProductMetafield(
      productData,
      "restaurantware",
      "customizable_product_min_price"
    );

    // Add customProduct class if is_customizeProduct is "true"
    if (is_customizeProduct === "true" || is_customizeProduct === true) {
      // console.log("ISW Product ID:", productId);
      // Fallback: also add to the link if needed
      const linkEl = productItem?.querySelector('.boost-sd__suggestion-queries-item-link');
      if (linkEl && !linkEl.classList.contains('customProduct')) {
        console.log("Adding customProduct class to ISW product image3");
        linkEl.classList.add('customProduct');
      }
    }

    // Add customizable badge to product image
    if (is_customizeProduct === "true" || is_customizeProduct === true) {
      // Find the left product image container inside the link
      const productImageContainer = productItem.querySelector(
        "a.boost-sd__suggestion-queries-item-link > .boost-sd__suggestion-queries-item-product.boost-sd__suggestion-queries-item-product--left"
      );
      const customizableBadgeHTML = `<span class="customizable-badge" aria-hidden="true" style="position: absolute; z-index: 1; top: 10px; max-width:125px; width: 68%;">
        <img src="https://cdn.shopify.com/s/files/1/0780/9987/4066/files/customizable_badge_icon_1.png" style="max-width: 14px" alt="Customizable Icon">
        Customizable
      </span>`;
      if (
        productImageContainer &&
        !productImageContainer.querySelector(".customizable-badge")
      ) {
        // Insert the badge as the last child of the left image container
        productImageContainer.insertAdjacentHTML("beforeend", customizableBadgeHTML);
                            console.log("Customizable badge added to ISW 2");
      }
    }

    const SKU = productData.skus[0];

    const brandNameHTML =
      brand_name != null
        ? `<div class="boost-sd-meta brandname caption-with-letter-spacing brand-name">${brand_name}</div>`
        : "<div class='boost-sd-meta'></div>";
    const subtitleHTML =
      subtitle != null
        ? `<div class="boost-sd-meta subtitle card__title">${subtitle}</div>`
        : "<div class='boost-sd-meta subtitle'></div>";
    const dimensionHTML =
      dimension != null
        ? `<div class="boost-sd-meta dimension card__description">${dimension}</div>`
        : "<div class='boost-sd-meta dimension'></div>";
    const skuHTML =
      SKU != null
        ? `<div class="boost-sd-meta sku sku-name">${SKU}</div>`
        : "<div class='boost-sd-meta sku'></div>";
    const countboxHTML =
      qty != null && SKU != "EXPOMIDATL25" && SKU != "EXPOBOSTON25"
        ? `<span class="boost-sd-meta count-box">/${qty}${is_customizeProduct === "true" || is_customizeProduct === true ? 'piece' : 'count box'}</span>`
        : "<div class='boost-sd-meta count-box'></div>";

    const customizableBadgeHTML = (is_customizeProduct === "true" || is_customizeProduct === true)
      ? `<span class="customizable-badge" aria-hidden="true" style="display: flex; position: absolute; z-index: 1; top: 21px; max-width:125px;">
          <img src="https://cdn.shopify.com/s/files/1/0780/9987/4066/files/customizable_badge_icon_1.png" style="max-width :14px" alt="Customizable Icon">
          Customizable
        </span>`
      : "";

    if (productItem) {
      // Add customizable badge to ISW product
      if (is_customizeProduct === "true" || is_customizeProduct === true) {
        console.log("Adding customizable badge to ISW product");
        // Try multiple possible selectors for the image container
        let productImageContainer = productItem.querySelector(".boost-sd__suggestion-queries-item-image") ||
                                  productItem.querySelector(".boost-sd__suggestion-queries-item-img") ||
                                  productItem.querySelector(".boost-sd__product-image") ||
                                  productItem.querySelector(".boost-pfs-search-suggestion-product-image");
        
        if (productImageContainer && !productImageContainer.querySelector(".customizable-badge")) {
          productImageContainer.insertAdjacentHTML("beforeend", customizableBadgeHTML);
          console.log("Customizable badge added to ISW 3");
        } else {
          console.log("Could not find image container or badge already exists");
        }

        const currencyEl = productItem.querySelector(".boost-sd__format-currency");
        // if (currencyEl) {
        //   currencyEl.style.display = "none";
        // }
        if (currencyEl && !currencyEl.querySelector(".from-text")) {
          currencyEl.insertAdjacentHTML("afterbegin", '<span class="from-text" style="font-size: 12px; margin-right: 2px;">From</span>');
        }

        // Update the price text to your desired value
        const priceEl = currencyEl ? currencyEl.querySelector("span:not(.from-text):not(.count-box)") : null;
        if (priceEl) {
          priceEl.textContent = czbl_min_price ? `$${czbl_min_price}` : ""; // Show czbl_min_price if available
        }
      }

      // Add custom class for customize product layout
      if (is_customizeProduct === "true" || is_customizeProduct === true) {                  
        // Try multiple selectors for ISW product image
        let productImage = productItem.querySelector(".boost-sd__suggestion-queries-item-img") ||
                          productItem.querySelector(".boost-sd__product-image") ||
                          productItem.querySelector(".boost-sd__suggestion-queries-item-image") ||
                          productItem.querySelector("img") ||
                          productItem;
        
        if (productImage && !productImage.classList.contains("customProduct")) {
          // console.log("Adding customProduct class to ISW product image");
          productImage.classList.add("customProduct");
        }
      }
      if (!productItem.querySelector(".subtitle")) {
        productItem
          .querySelector(".boost-sd__suggestion-queries-item-sku")
          .insertAdjacentHTML("beforebegin", subtitleHTML);
      }

      if (!productItem.querySelector(".brand-name")) {
        productItem
          .querySelector(".boost-sd-meta.subtitle")
          .insertAdjacentHTML("beforebegin", brandNameHTML);
      }

      if (!productItem.querySelector(".dimension")) {
        productItem
          .querySelector(".boost-sd-meta.subtitle")
          .insertAdjacentHTML("afterend", dimensionHTML);
      }

      if (!productItem.querySelector(".sku")) {
        productItem
          .querySelector(".boost-sd__suggestion-queries-item-price")
          .insertAdjacentHTML("beforebegin", skuHTML);
      }

      if (!productItem.querySelector(".count-box")) {
        productItem
          .querySelector(".boost-sd__format-currency")
          .insertAdjacentHTML("beforeend", countboxHTML);
      }
      if ((is_customizeProduct === "true" || is_customizeProduct === true) && productId) {
        // Add customProduct class to quick view if exists
        let quickViewEl = document.querySelector('.boost-sd__quick-view[data-product-id="' + productId + '"]');
        let customizableViewEl = document.querySelector('.boost-sd-meta.dimension.card__description');
        if (quickViewEl && !quickViewEl.classList.contains("customProduct")) {
          quickViewEl.classList.add("customProduct");
        }

        if (customizableViewEl && !customizableViewEl.classList.contains("customizable-item")) {
          customizableViewEl.classList.add("customizable-item");
        }
      }
    }

    // End-------------------------------------------------------------
  } catch (e) {
    console.warn(e);
  }
}


/*********************** Hide Price if user is not login  ************************/
const customizeHidePrice = {
    customizeProductItemPrice: (componentRegistry) => {
        function hidePrice(element, isProductGrid) {
            try {
                let productData = element.getParams().props.product;
                let productId = productData.id;
                if (productData?.split_product) {
                    productId = productData.variant_id;
                }
                let productItem = isProductGrid ? document.querySelector('[data-product-id="' + productId + '"]') : document.querySelector('[data-id="' + productId + '"]');
                let customerIsLogged = window.boostSDData?.customer?.isLogged;
                if (productData && productItem && !customerIsLogged) {
                    if (isProductGrid) {
                        productItem.querySelector('.boost-sd__product-price')?.remove();
                    } else {
                        productItem.querySelector('.boost-sd__suggestion-queries-item-price')?.remove();
                    }
                }
            } catch (e) {
                console.error(e);
            }
        }
        const hideProductPrice = {
            name: 'Hide price based on customer #184928',
            enabled: true,
            apply: () => ({
                afterRender(element) {
                    hidePrice(element, true);
                }
            })
        };

        const hideProductPriceSearch = {
            name: 'Hide price based on customer #184928',
            enabled: true,
            apply: () => ({
                afterRender(element) {
                    hidePrice(element, false);
                }
            })
        }
        // Register updateProductGrid
        // componentRegistry.useComponentPlugin('ProductItem', hideProductPrice);
        componentRegistry.useComponentPlugin('SearchProductItem', hideProductPriceSearch);
    }
}
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customizeHidePrice.customizeProductItemPrice]);

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat(
  (registry) => {
    registry.useModulePlugin("SearchAPI", {
      name: "Extra data SearchAPI",
      apply(builder) {
        // Logic run isw (API Suggest), please only edit in TODO: do something - ts
        builder.on("methodFulfilled", "get", (response) => {
          if(!response.result?.suggestions){
              response.result.suggestions = [] ;
          }
        });
      },
    });
  }
);